import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { PlusCircle, LayoutDashboard, Inbox, Send, FileText, Edit3, Trash2, Building2, BarChart3, Settings, Users, CalendarDays, FolderKanban, History } from "lucide-react";
import { api } from "@/lib/api";

const NAV_GROUPS = [
  {
    label: "Обзор",
    items: [{ to: "/", label: "Главная", icon: LayoutDashboard, key: null, end: true }],
  },
  {
    label: "Документооборот",
    items: [
      { to: "/documents/incoming", label: "Входящие", icon: Inbox, key: "incoming" },
      { to: "/documents/outgoing", label: "Исходящие", icon: Send, key: "outgoing" },
      { to: "/documents/internal", label: "Внутренние", icon: FileText, key: "internal" },
      { to: "/documents/drafts", label: "Черновики", icon: Edit3, key: "drafts" },
      { to: "/documents/deleted", label: "Удалённые", icon: Trash2, key: "deleted" },
    ],
  },
  {
    label: "Бизнес",
    items: [
      { to: "/counterparties", label: "Контрагенты", icon: Building2, key: null },
      { to: "/reports", label: "Отчёты и аналитика", icon: BarChart3, key: null },
      { to: "/calendar", label: "Календарь", icon: CalendarDays, key: null },
      { to: "/projects", label: "Проекты", icon: FolderKanban, key: null },
      { to: "/audit-log", label: "Журнал действий", icon: History, key: null },
    ],
  },
  {
    label: "Настройки",
    items: [
      { to: "/team", label: "Команда и доступ", icon: Users, key: null },
      { to: "/settings", label: "Настройки", icon: Settings, key: null },
    ],
  },
];

export function Sidebar({ onNewDocument, refreshKey, mobile = false, onNavigate }) {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api
      .get("/documents/counts")
      .then(({ data }) => setCounts(data))
      .catch(() => {});
  }, [refreshKey]);

  const wrapperClass = mobile
    ? "flex flex-col h-full overflow-y-auto"
    : "hidden md:flex w-64 bg-white border-r border-slate-200 flex-col py-4 shrink-0 h-[calc(100vh-56px)] sticky top-14 overflow-y-auto";

  return (
    <aside className={wrapperClass} data-testid="sidebar-nav">
      <div className="px-4 mb-4">
        <button
          onClick={() => {
            onNewDocument();
            onNavigate?.();
          }}
          data-testid="create-doc-button"
          className="flex items-center gap-2 w-full justify-center rounded-lg bg-slate-900 text-white text-sm font-medium py-2.5 hover:bg-slate-800 transition-colors"
        >
          <PlusCircle className="w-4 h-4" /> Новый документ
        </button>
      </div>
      {NAV_GROUPS.map((group) => (
        <div key={group.label} className="mb-5">
          <div className="px-5 text-[11px] font-semibold uppercase tracking-wider text-slate-400 mb-1.5">{group.label}</div>
          {group.items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => onNavigate?.()}
              data-testid={`nav-${item.to === "/" ? "dashboard" : item.to.replace(/\//g, "-").replace(/^-/, "")}`}
              className={({ isActive }) =>
                `flex items-center justify-between gap-2 px-5 py-2 text-sm transition-colors ${
                  isActive ? "bg-blue-50 text-blue-700 font-medium border-r-2 border-blue-600" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
            >
              <span className="flex items-center gap-2.5">
                <item.icon className="w-4 h-4" />
                {item.label}
              </span>
              {item.key && counts[item.key] > 0 && (
                <span className="text-xs bg-slate-100 text-slate-600 rounded-full px-2 py-0.5">{counts[item.key]}</span>
              )}
            </NavLink>
          ))}
        </div>
      ))}
    </aside>
  );
}
